import type { FileUploadService } from '@application/FileUploadService';
import { makeContext } from '@shared/makeContext';

export const {
  Provider: FileUploadServiceProvider,
  useContext: useFileUploadService,
} = makeContext<FileUploadService>('FileUploadService');
